import { useModalStore } from "@/stores/use-modal-store";
import { XMarkIcon } from "@heroicons/react/20/solid";
import ScenePOWImg from "@/assets/report-assets/scene-pow-tooltip.png";

/*
 * POWInfoModal component
 *
 * This modal displays information about the Attention Power Factor (POW) metric.
 */
export const POWInfoModal = () => {
  /* Hooks */
  const { close } = useModalStore((state) => state.modalActions);

  /* Render */
  return (
    <div className="flex flex-col gap-6">
      {/* Header */}
      <div className="flex items-center justify-center relative">
        <h2>POW (Attention Power Factor)</h2>
        <XMarkIcon onClick={close} className="size-5 cursor-pointer absolute right-0" />
      </div>

      {/* Image */}
      <div className="flex items-center justify-center">
        <img src={ScenePOWImg} alt="POW visualization" className="w-[261px] rounded-lg" />
      </div>

      {/* Description */}
      <p className="text-center">Attention Power Factor shows the share of attention an element receives relative to its size.</p>
    </div>
  );
};
